import { render, staticRenderFns } from "./PreoperationNotes.vue?vue&type=template&id=31b4f5aa&"
import script from "./PreoperationNotes.vue?vue&type=script&lang=js&"
export * from "./PreoperationNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports